import { makeGetRequest } from 'owa-ows-gateway';
import { ActivityFeedResponse } from './ActivityFeedResponse';
import { getUrlWithAddedQueryParameters } from 'owa-url';
import { isFeatureEnabled } from 'owa-feature-flags';

const GET_ACTIVITY_FEED_URL: string = 'ows/v1.0/ActivityFeed';
const GET_ACTIVITY_FEED_URL_V2: string = 'ows/v2.0/ActivityFeed';

export const getActivityFeed: (
    activityFeedFilter: string[]
) => Promise<ActivityFeedResponse> = activityFeedFilter => {
    let url = '';
    if (isFeatureEnabled('auth-activityFeedV2Schema')) {
        url = GET_ACTIVITY_FEED_URL_V2;
    } else {
        url = GET_ACTIVITY_FEED_URL;
    }

    if (activityFeedFilter) {
        activityFeedFilter.forEach(item => {
            url = getUrlWithAddedQueryParameters(url, { TypesToExclude: item });
        });
    }
    return makeGetRequest(url);
};
